import { useMutation } from "react-query";
import { paywallCheckoutApi } from "@circle-react/api/paywallCheckoutApi";
import type { PreviewError } from "@circle-react/contexts/Paywalls/usePaywallCheckout";

export const usePreviewMutation = () =>
  useMutation<any, PreviewError, any>(params =>
    paywallCheckoutApi.preview(params),
  );
